'use es6';

import 'i18n-data/data/baseLocales';